import {useState} from "../../../__snowpack__/pkg/react.js";
import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
export const useGetAlertEmails = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/saas/member/v1/alert-receiver/find-by-merchantUserId");
      let result;
      if (res && Array.isArray(res.data)) {
        setData(res.data);
        result = res.data;
      } else {
        setData([]);
        result = [];
      }
      return {data: result};
    } catch (error) {
      handleError(error);
      return {data: []};
    } finally {
      setLoading(false);
    }
  };
  return {
    loading,
    data,
    fetchData
  };
};
